import { lenis, initScrollControl } from './include/_lenis.js';
import { subMenu } from './include/_submenu.js';
import { textAnimations } from './include/_textAnimations.js';
import { waveScroll, scrollParallax, scrollTopPosition } from './include/_gsap.js';
import scrollIn from './include/_scrollIn.js';
import { variables } from './include/_variables.js';
import { responsiveAccordion } from './include/_responsive.js';
import { followMenu } from './include/_follow-menu.js';
import { numbers } from './include/_numbers.js';
import { performancePosts } from './include/_performance-post.js';
import { tabAction } from './include/_tab-action.js';
import { viewTransition } from './include/_viewTransition.js';
import { postGallerySwiper } from './include/_swiper.js';

const initScripts = () => {

  if (typeof lenis === 'function') 
    lenis();

  if (typeof initScrollControl === 'function') {
    const firstTargetEl = document.querySelector('.first-content');
    const mainVisual = document.querySelector('.main-visual');
    if (firstTargetEl && mainVisual) {
        initScrollControl(mainVisual, firstTargetEl);
    }
  }

  // if (typeof viewTransition === 'function')
  //   viewTransition(); 

  if (typeof waveScroll === 'function') 
    waveScroll('.js-waveScroll-trigger', '.js-waveScroll-cover');

  if (typeof subMenu === 'function') 
    subMenu({
      isBlur: true,
    });

  if (typeof responsiveAccordion === 'function') 
    responsiveAccordion();
  
  if (typeof textAnimations === 'function') 
    textAnimations();

  if (typeof scrollIn === 'function') 
    scrollIn();

  if (typeof scrollParallax === 'function') 
    scrollParallax('.scroll-parallax');

  if (typeof scrollTopPosition === 'function') 
    scrollTopPosition({ 
      target: '.js-scroll-position', 
      threshold: document.querySelector('header').offsetTop, 
      className: 'is-scroll-sticky' 
    });

  if (typeof followMenu === 'function') 
    followMenu();

  if (typeof numbers === 'function') 
    numbers();

  if (typeof tabAction === 'function') 
    tabAction();


  // performancePostsの初期化
  if (document.querySelector('.js-performance-posts')) {  // 要素の存在確認を追加
    console.log('Initializing performance modal...');  // デバッグ用
    performancePosts.init();
  }

  if (typeof postGallerySwiper === 'function') 
    postGallerySwiper();

}

document.addEventListener('DOMContentLoaded', initScripts, false);
